<template lang="pug">
  ul.contextMenu(:class='{hide: !open}', ref="contextmenu")
    li(v-for='item in items', @mousedown='onClick(item, $event)')
      i.fa(:class='"fa-"+item.icon', v-if='item.icon')
      | {{item.name}}
</template>
<script>
import $ from 'jquery'

export default {
  data () {
    return {
      open: false,
      object: void 0,
      items: []
    }
  },
  created () {
    return $('body').on('contextmenu', this.openOn)
  },
  methods: {
    openOn (event) {
      var contextMenuItems, element, _ref
      element = $(event.target).closest('.ctx')
      contextMenuItems = element.data('contextmenu')
      contextMenuItems = (_ref = typeof contextMenuItems === 'function' ? contextMenuItems() : void 0) != null ? _ref : contextMenuItems
      if (contextMenuItems === false || (contextMenuItems == null)) {
        return
      }
      event.preventDefault()
      this.object = element
      this.items = contextMenuItems.slice()
      this.open = true
      $('body').on('click.contextmenu', this.close)
      this.$nextTick(() => {
        var $ctx, left, top
        left = event.pageX
        top = event.pageY
        $ctx = $(this.$refs.contextmenu)
        if (left + $ctx.width() > $(window).width()) {
          left = $(window).width() - $ctx.width() - 5
        }
        if (top + $ctx.height() > $(window).height()) {
          top = $(window).height() - $ctx.height() - 5
        }
        $(this.$refs.contextmenu).css({
          'top': top + 'px',
          'left': left + 'px'
        })
      })
    },
    close () {
      $('body').off('click.contextmenu')
      this.open = false
    },
    onClick (item, $event) {
      this.close()
      this.$nextTick(() => {
        item.callback($event)
      })
    }
  }
}
</script>
<style lang="sass">
.contextMenu
  position: absolute
  z-index: 9999
  top: 0
  left: 0
  background-color: white
  margin: 0
  padding: 0
  list-style: none
  box-shadow: 0 2px 5px rgba(0,0,0,0.5)
  li
    padding: 10px 10px 10px 5px
    cursor: pointer
    white-space: nowrap
    &:hover
      background-color: rgba(0,0,0,0.2)
    i
      width: 30px
      text-align: center
</style>



// WEBPACK FOOTER //
// ContextMenu.vue?61b0ec9a